import { defineMessages } from 'react-intl';

export default defineMessages({
  Budget: 'Budget',
  BudgetOverview: 'Budget overview',
  NoDataFound: 'No data found',
  Relation: 'Relation',
  Assignment: 'Assignment',
  Period: 'Period',
  BudgetAmount: 'Budget amount',
  ActualAmount: 'Actual amount',
  RemainingAmount: 'Remaining amount',
  BudgetAmountUsedPct: 'Used amount %',
  BudgetHours: 'Budget hours',
  TotalBudgetAmount: 'Total budget amount',
  TotalBudgetHours: 'Total budget hours',
  ActualHours: 'Actual hours',
  RemainingHours: 'Remaining hours',
  BudgetHoursUsedPct: 'Used hours %',
  PlannedDurationHours: 'Planned hours',
  BudgetVsPlannedDeviationPct: 'Budget deviation %',
  PlannedDuration: 'Planned duration',
  BudgetEqualsPlannedDuration: 'Budget and planned duration are equal',
  Year: 'Year',
  WithBudget: 'With budget',
  WithoutBudget: 'Without budget',
  DeleteBudget: 'Delete budget',
  DeleteBudgetMsg: 'Are you sure you want to delete this budget?',
  InvoiceSchedules: 'Invoice schedules',
  AllBudgetsSelected: 'All budgets selected',
  CountBudgetsSelected: 'Selected {count} budgets',
  ExportToExcel: 'Export to Excel',
  GlobalActions: 'Global actions',
  UpdateBudgetAmount: 'Update budget amount',
  UpdateAmountForYear: 'Update amount for year {year}',
  UpdateBudgetHours: 'Update budget hours',
  UpdateHoursForYear: 'Update hours for year {year}',
  OverrideIfBudgetExists: 'Override budget if one is already present',
  UseForfaitAmountAsBudgetAmount: 'Use forfait amount as budget amount',
  UseRegistrationAmountAsBudgetAmount: 'Use registration amount as budget amount',
  UseInvoiceAmountAsBudgetAmount: 'Use invoice amount as budget amount',
  UseRegistrationHoursForBudget: 'Use registration hours for budget',
  UsePlannedHoursForBudget: 'Use planned hours for budget',
  UseAdvanceAmountAsBudgetAmount: 'Use advance amount as budget amount',
  NewAmount: 'New amount',
  NewQuantity: 'New quantity',
  Amount: 'Amount',
  Hours: 'Hours',
  Method: 'Method',
  BudgetBasedOnYear: 'Based on year',
  CopyBudgetToYear: 'Copy budget to year',
  CopyBudget: 'Copy budget',
  GlobalActionStarted: 'Global action started',
  ExportToExcelStarted: 'Export to Excel started',
  ShowInvoicingHistory: 'Show invoicing history',
  IncludeInactiveRelations: 'Show inactive',

  IncludeExForfaitRegistrations: 'Include registrations not included in fixed amount',

  FiltersForBudgetCalculations: 'Filters for budget calculations',
  ShowInRegistrationOverview: 'Show in registration overview',
  BudgetSpreadOverPeriod: 'Budget spread over period',

  CopyBudgetYearFilterInfo: 'This year can be changed by changing the year filter in the overview',

  ColumnConfig: 'Configure columns',
  SelectColumns: 'Select columns',
  AddOrSubtractPercentage: 'Add or subtract percentage',
  Digits: 'Digits',
  RoundTo: 'Round to',
  RoundingMethod: 'Rounding method',
  Example: 'Example',
  Percentage: 'Percentage',
  AddOrSubtractAmount: 'Add or subtract amount',
  OpenBudgetSettings: 'Open budget settings',
});
